import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper, isAndroid } from './columnHelper'
import { NotApplicable, Unavailable } from './MissingData'

const key = IdentificationUrlKeys.ClonedApp
const label = visitFilterLabelMap[key]

export const clonedAppColumn = () =>
  columnHelper.display({
    id: 'clonedApp',
    header: 'Cloned App',
    cell: ({ row }) => {
      if (!isAndroid(row.original)) {
        return <NotApplicable />
      }

      const result = row.original.cloned_app

      if (result == null) {
        return <Unavailable />
      }

      return (
        <CellAction search={(old) => ({ ...old, [key]: result })} field={label}>
          <Typography className={result ? 'text-red-800' : ''}>{result ? 'Yes' : 'No'}</Typography>
        </CellAction>
      )
    },
  })
